// Une offre multi-channel (ex. Leroy Merlin FR/ES/PT/IT/BM) devient une ligne-mère
// avec une sous-ligne par channel ; les autres offres restent sur une seule ligne.

export const channelRowKey = (offerId, channelCode) =>
  `${offerId}-${channelCode}`;

const buildChannelRow = (offer, channel) => ({
  ...offer,
  rowKey: channelRowKey(offer.id, channel.code),
  offerId: offer.id,
  channel,
});

// Avec un filtre pays, seules les sous-lignes de ce pays sont gardées.
export const buildOfferRows = (offers, country) =>
  (offers ?? []).map((offer) => {
    const channels = (offer.channels ?? []).filter(
      (channel) => !country || channel.country === country
    );
    if (channels.length === 0) return { ...offer, rowKey: offer.id };
    return {
      ...offer,
      rowKey: offer.id,
      children: channels.map((channel) => buildChannelRow(offer, channel)),
    };
  });

// Sous-lignes repliées par défaut ; avec un filtre pays, on ouvre sur le channel filtré.
export const defaultExpandedRowKeys = (rows, country) => {
  if (!country) return [];
  return rows.filter((row) => row.children).map((row) => row.rowKey);
};

// Clés cochées : l'offre et toutes ses sous-lignes, puisqu'on publie l'offre complète.
export const selectedRowKeysFor = (rows, selectedOffers) => {
  const selectedIds = new Set(selectedOffers.map((offer) => offer.id));
  const childKeys = rows
    .filter((row) => selectedIds.has(row.id))
    .flatMap((row) => (row.children ?? []).map((child) => child.rowKey));
  return [...selectedIds, ...childKeys];
};
